export const LineSeparator = () => {
  return (
    <hr
      style={{
        width: "110px",
        color: "#dd2822",
        border: 0,
        borderTop: "1px solid",
        opacity: "90%",
      }}
    />
  );
};
